import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

// Fire a fire-and-forget visit ping on every route change. Never blocks
// rendering, never surfaces errors to the UI.
export default function useVisitPing() {
  const location = useLocation();
  useEffect(() => {
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/analytics/visit`;
      const body = JSON.stringify({ path: location.pathname });
      if (navigator.sendBeacon) {
        const blob = new Blob([body], { type: "application/json" });
        navigator.sendBeacon(url, blob);
      } else {
        api.post("/analytics/visit", { path: location.pathname }).catch(() => {});
      }
    } catch { /* swallow */ }
  }, [location.pathname]);
}
